import {Injectable, EventEmitter} from '@angular/core';

@Injectable()
export class NavigationBarService {
  selectedTabChange: EventEmitter<number> = new EventEmitter<number>();
  selectedTab: number;

  constructor() {
  }

  clear() {
    this.selectedTab = 0;
    this.selectedTabChange.emit(this.selectedTab);
  }

  setSelectedTab(selectedTab) {
    this.selectedTab = selectedTab;
    this.selectedTabChange.emit(this.selectedTab);
  }

  getSelectedTab() {
    return this.selectedTab;
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/navigation-bar.service.ts